/* tslint:disable */
/* eslint-disable */
export enum LineItemType {
  FlightLeg = 'FLIGHT_LEG',
  AdditionalCharge = 'ADDITIONAL_CHARGE',
  Other = 'OTHER',
  ServiceFee = 'SERVICE_FEE',
  AirfareForClient = 'AIRFARE_FOR_CLIENT',
  AirfareForMedicalEscort = 'AIRFARE_FOR_MEDICAL_ESCORT',
  MedicalCrewCosts = 'MEDICAL_CREW_COSTS',
  Lodging = 'LODGING',
  Equipments = 'EQUIPMENTS',
  GroundTransportPickUp = 'GROUND_TRANSPORT_PICK_UP',
  GroundTransportArrival = 'GROUND_TRANSPORT_ARRIVAL',
  GroundForMedicalEscort = 'GROUND_FOR_MEDICAL_ESCORT',
  MiscExpense1 = 'MISC_EXPENSE_1',
  MiscExpense2 = 'MISC_EXPENSE_2',
  BankCreditCardFee = 'BANK_CREDIT_CARD_FEE',
}
